// extracted by mini-css-extract-plugin
export default {"modal":"CancelModal_modal__IlXQw"};